import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUser, useClerk } from '@clerk/clerk-react'
import { usePlayerStore } from '../../stores/usePlayerStore'
import { LanguageSelector } from '../ui/LanguageSelector'

export const Header: React.FC = () => {
  const { t } = useTranslation()
  const { player } = usePlayerStore()
  const { user } = useUser()
  const { signOut } = useClerk()

  const handleLogout = () => {
    signOut()
  }

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="px-6 py-4">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">
              {t('auth.welcomeBack')}, {user?.firstName || user?.username || player?.username || t('common.player')}!
            </h2>
            <p className="text-sm text-gray-600">
              {t('dashboard.playerLevel')} {player?.level || 1} - {t('dashboard.experience')}: {player?.experience || 0}
            </p>
          </div>
          <div className="flex items-center space-x-6 space-x-reverse">
            <LanguageSelector />
            <div className="text-right">
              <p className="text-sm text-gray-600">{t('dashboard.cashBalance')}</p>
              <p className="text-2xl font-bold text-green-600">
                {player?.cash?.toLocaleString() || '1,000'} 💰
              </p>
            </div>
            <div className="flex items-center space-x-3 space-x-reverse">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-lg">
                  {(user?.firstName || user?.username || player?.username || 'U').charAt(0).toUpperCase()}
                </span>
              </div>
              <button
                onClick={handleLogout}
                className="text-sm text-gray-600 hover:text-gray-800 transition-colors"
              >
                {t('auth.logout')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
